// extracted by mini-css-extract-plugin
module.exports = {"container":"LandingV2_container__3TACy","section-title":"LandingV2_section-title__23nX_","testimonials-section":"LandingV2_testimonials-section__3biBW"};